
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import CircleIcon from '@components/shared/icons/CircleIcon.vue';

@Component({
  name: 'EcoScoreSectionItem',
  components: {
    CircleIcon
  }
})
export default class EcoScoreSectionItem extends Vue {
  @Prop({ required: true })
  private name: string;

  @Prop({ required: true })
  private value: number;

  @Prop({ required: true })
  private color: string;
}
